'use client'

import { cn } from '@mntn-dev/ui-utilities'
import type { TestIds } from '../../../utils/testing.ts'
import type { IconProps } from '../../icon/icon.tsx'
import { Skeleton } from '../../skeleton/skeleton.tsx'
import { AvatarIcon } from '../avatar-icon.tsx'
import type { AvatarProps } from '../types.ts'
import { useAvatar } from '../use-avatar.ts'

export type AvatarSkeletonProps = TestIds &
  Pick<AvatarProps, 'className' | 'size'> &
  Partial<Pick<IconProps, 'name'>>

export const AvatarSkeleton = ({
  size = 'med',
  name: iconName,
  ...avatarProps
}: AvatarSkeletonProps) => {
  const context = useAvatar({ size })
  const { sizeClassName } = context
  return (
    <Skeleton
      {...avatarProps}
      className={cn('rounded-full', sizeClassName, avatarProps.className)}
    >
      {iconName && (
        <AvatarIcon name={iconName} className="text-transparent fill-wt-100" />
      )}
    </Skeleton>
  )
}
